import { YStack, Text } from 'tamagui'
import type { StatSlide as StatSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor, getAccentGlow } from './shared'

export function StatSlide({ slide }: { slide: StatSlideType }) {
  const accentColor = getAccentColor(slide.accent)
  return (
    <SlideContainer>
      <SlideInner alignItems="center" style={{ padding: 'clamp(32px, 6vw, 80px)' }}>
        <Text
          fontFamily="$heading"
          fontWeight="800"
          color={accentColor}
          style={{
            fontSize: 'clamp(60px, 12vw, 160px)',
            textShadow: getAccentGlow(slide.accent),
            lineHeight: '1em',
          }}
        >
          {slide.number}
        </Text>
        <Text
          fontFamily="$mono"
          color="$textSecondary"
          textAlign="center"
          style={{ fontSize: 'clamp(14px, 2vw, 24px)', maxWidth: '600px' }}
        >
          {slide.label}
        </Text>
        {slide.body && (
          <Text
            fontFamily="$body"
            color="$textMuted"
            textAlign="center"
            marginTop="$4"
            style={{ fontSize: 'clamp(12px, 1.5vw, 18px)', maxWidth: '500px' }}
          >
            {slide.body}
          </Text>
        )}
      </SlideInner>
    </SlideContainer>
  )
}
